type Props = {
  fillColor?: string;
};

export const CollapseIcon = ({ fillColor = '#757575' }: Props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path d="M12 8.39844L18.025 14.3984L5.97499 14.3984L12 8.39844Z" fill={fillColor} />
  </svg>
);
